import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import { Center, Wrapper } from './PlanExports.styles'
import { useReplenishmentPlanExportsQuery } from '@/core/api/graphql/forshawGraphqlApi.generated.ts'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'

const PlanExports = () => {
  const { t } = useTranslation()

  const [dateFilter] = useState({
    from: new Date(
      new Date().setMonth(new Date().getMonth() - 1),
    ).toISOString(),
    to: new Date().toISOString(),
  })

  const { data: { replenishmentPlanExports } = {} } =
    useReplenishmentPlanExportsQuery(dateFilter)

  return (
    <Wrapper>
      {replenishmentPlanExports?.length === 0 && (
        <Center>{t('planExports.notFound')}</Center>
      )}

      {Boolean(replenishmentPlanExports?.length) && (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>{t('planExports.table.file')}</TableCell>
                <TableCell>{t('planExports.table.createdAt')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {replenishmentPlanExports!.map((planExport) => {
                const fileSplit = planExport.file.split('/')
                const fileName = fileSplit[fileSplit.length - 1]

                return (
                  <TableRow key={planExport.id}>
                    <TableCell component="th" scope="row">
                      <a href={planExport.file}>{fileName}</a>
                    </TableCell>
                    <TableCell>
                      {new Date(planExport.createdAt).toLocaleDateString()}
                    </TableCell>
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Wrapper>
  )
}

export default PlanExports
